var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitKeeplogoforwalletconnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512 0C794.8 0 1024 229.2 1024 512C1024 794.8 794.8 1024 512 1024C229.2 1024 0 794.8 0 512C0 229.3 229.2 0 512 0Z",
    fill: "#7524F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M830.4 354.3V390.5C830.4 397.6 826.6 404.2 820.5 407.7L703.9 475L808 534.9C821.9 542.9 830.4 557.7 830.4 573.7V670.1C830.4 686.1 821.8 700.9 807.9 708.9L534.1 866C520.3 873.9 503.3 873.9 489.4 865.9L399.8 814.1C393.2 810.3 393.2 800.7 399.8 796.9L695.6 626.6C698.9 624.7 698.9 619.9 695.6 618L585.7 554.5C579.6 550.9 572 550.9 565.8 554.5L265.2 727.7C260.6 730.3 254.9 730.4 250.3 727.7L216.3 708.2C202.4 700.2 193.8 685.4 193.8 669.3V629.8C193.8 624.5 196.7 619.5 201.3 616.9L632.2 369.3C635.5 367.4 635.5 362.6 632.2 360.7L522.2 297C516.1 293.4 508.5 293.4 502.3 297L208.7 465.9C202.1 469.7 193.8 464.9 193.8 457.3V353.8C193.8 337.8 202.4 323 216.3 315L490.1 157.9C503.9 150 520.9 150 534.7 157.9L807.9 315.5C821.8 323.6 830.4 338.3 830.4 354.3Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitKeeplogoforwalletconnect);
export default __webpack_public_path__ + "static/media/BitKeep logo for wallet connect.ee0459b699dd0bdbed7f85b92fe558c5.svg";
export { ForwardRef as ReactComponent };